"use client"

import VenueMenusClient from "./VenueMenusClient"
import { PETIT_DEJEUNER_VENUE_CONFIG } from "../lib/venue-menus-client/venueMenusClientConfig"

const PetitDejeunerClient = () => <VenueMenusClient config={PETIT_DEJEUNER_VENUE_CONFIG} />

export default PetitDejeunerClient
